<template>

  <!-- selector de cliente -->
  <div class="text-xs-center" v-if="muestraSelecccionCliente" style="margin-left:8px">
    <v-avatar class="grey data-cpointer" style="max-height: 40px; max-width: 40px;" @click="showMiCuenta()">
      <v-icon dark>person</v-icon>
    </v-avatar>
  </div>

</template>

<script>

export default {
  name: 'ShpSeleccionCliente',
  components: {

  },
  props: {
    moduloApp: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      modulo: this.$store.getters.getModulo,
      headers: [{},
        {
          text: 'Codigo',
          align: 'left',
          sortable: false,
          value: 'name'
        }, {
          text: 'Cliente', value: 'calories'
        }],
      clientes: [],
      muestraSelecccionCliente: this.modulo === 'TIENDA',
      menu: false,
      search: ''
    }
  },
  watch: {
    moduloApp: {
      handler () {
        this.modulo = this.$store.getters.getModulo
        this.muestraSelecccionCliente = (this.modulo === 'TIENDA')
      }
    }
  },
  created () {
    // mira si activa o no la opción de menu
    this.muestraSelecccionCliente = (this.modulo === 'TIENDA')
  },
  beforeDestroy () {
  },
  methods: {
    /*
     * carga de datos
     */
    /*
     * Evento para lanzar la carga de datos
     */
    showMiCuenta () {
      this.$router.push('/miCuenta')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Catalogo/ShpSeleccionCliente.vue